import { Component } from '@angular/core';
import { HomePricingComponent } from '../home/home-pricing/home-pricing.component';
import { HomeBottomLinksComponent } from '../home/home-bottom-links/home-bottom-links.component';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-market',
  standalone: true,
  imports: [HomePricingComponent, HomeBottomLinksComponent, ToastModule],
  templateUrl: './market.component.html',
  styleUrl: './market.component.scss'
})
export class MarketComponent {

}
